var map = {
	"./smz.png": 9827,
	"./smz1.png": 2290,
	"./smz2.png": 5435,
	"./smz3.png": 8351,
	"./smz4.png": 7754,
	"./smz5.png": 7029,
	"./smzz.png": 9384
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1401;